import React, { Component } from 'react';

export default class About extends Component {
  render() {
    return (
      <React.Fragment>
      {
		<section id="about">
			<div className="row">
				<div className="three columns">
					<img className="profile-pic" src="images/profilepic.jpg" alt />
				</div>
			 
				<div className="nine columns main-col">
					<h2>About Me</h2>
					<p>
					Hello, my name is Gabriele Cassano, I'm 40 years old, I decided to move in the field of computer development and no longer work in the manual sector, after
					graduating and obtained my Bachelor's degree in computer science management in 2013. 
					<br/>
					Passionate for ten years of computer science and music since the age of 15, these two practices allow me to exercise precision, rigor and artistic openness.
					<br/>
					Having chosen my specialization by passion, after having chosen to realize a local media rental site, with an administration interface, allowing to modify all the site, 
					it pleased me it became my professional project: I would like a job as a web developer.
					<br/>
					My strengths are: HTML5, CSS3, PHP, JavaScript, jQuery, Json, WordPress, Drupal.
					</p>
					
					<div className="row">
						<div className="columns contact-details">
							<h2>Contact Details</h2>
							<p className="address">
								<span>Cassano Gabriele</span><br />
								 <span>
								 Rue Saint-Alphonse, 180
								 <br />
								 7110 Strépy-bracquegnies
								 <br/>
								 Belgique
								 </span>
								 <br />
								<span>(+32)497 62 10 10</span>
								<br />
								<span>gabriel_cassano@hotmail.com</span>
							</p>
						</div>
						
						<div className="columns download">
							<p>
							<a href="http://portfolio.gabriel-cassano.be/pdf/curriculumvitae.pdf" download="curriculumvitae.pdf" className="button"><i className="fa fa-download" />Download Resume</a>
							</p>
						</div>
					</div> 
			  </div> 
			</div>
		</section>  		  
	  }   
      </React.Fragment>
    );
  }
}
